/** @jsx jsx */
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { jsx } from "theme-ui"

export default function Ornament1(props){
    const data = useStaticQuery(graphql`
        query {
            file(sourceInstanceName: {eq: "backgrounds"}, name: {eq: "ornament1"}) {
                childImageSharp {
                 fluid(quality:80) {
                    ...GatsbyImageSharpFluid_withWebp
                 }
                }
            }
        }      
    `)
    const imageData = data.file.childImageSharp.fluid

    return(
        <div sx={{
            filter: 'drop-shadow(-16px 16px 32px rgba(0,0,0,0.5))',
        }}>
            <Img fluid={imageData} alt="Food Plate"/>
        </div>
    )
}